/**
 * Typography primitives for the Brand 2026 Customer theme.
 *
 * @remarks
 * Prefer using the typography theme tokens, as they are more stable and less likely to change.
 */
export const typography = {
  heading: {
    fontFamily: "'NOTHS Suisse Neue', 'NOTHS Suisse Neue Fallback', 'Lato', Arial, sans-serif",
    fontWeight: 500,
    letterSpacing: '-4%',
    sizes: {
      xs: { fontSize: '18px', lineHeight: '24px' },
      sm: { fontSize: '20px', lineHeight: '28px' },
      md: { fontSize: '24px', lineHeight: '32px' },
      lg: { fontSize: '30px', lineHeight: '38px' },
      xl: { fontSize: '36px', lineHeight: '44px' },
      xxl: { fontSize: '48px', lineHeight: '56px' },
    },
  },
  body: {
    fontFamily: "'Lato', Arial, sans-serif",
    fontWeight: 400,
    letterSpacing: '1%',
    sizes: {
      sm: { fontSize: '13px', lineHeight: '18px' },
      md: { fontSize: '15px', lineHeight: '20px' },
      lg: { fontSize: '17px', lineHeight: '24px' },
    },
  },
} as const;
